<template>
    <div class="goods-add pb50">
        <!--添加-->
        <el-form ref="form" size="small" :model="form" :rules="rules" label-width="100px">
            <div class="common-form">添加批次</div>
            <el-form-item label="批次名称" prop="name">
                <el-input v-model="form.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="总数量" prop="batch_num">
                <el-input-number v-model="form.batch_num" :min="0" :step="1" :precision="0" step-strictly></el-input-number>
            </el-form-item>
            <el-form-item label="开始时间" prop="start_time">
                <el-date-picker style="width:330px;"
                                v-model="dateArr"
                                @change="datePickerChange($event,'')"
                                type="datetimerange"
                                range-separator="至"
                                placeholder="选择时间"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="pickerOptions"
                                clearable>
                </el-date-picker>
            </el-form-item>

            <!--提交-->
            <div class="common-button-wrapper">
                <el-button size="small" type="info" :loading="loading" @click="cancelFunc">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="onSubmit">提交</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
    import PlatformActivityApi from "@/api/platformactivity.js";
    import formOperate from "@/utils/formOperate.js";

    export default {
        mixins: [formOperate],
        components: {
        },
        data() {
            return {
                /*form表单数据*/
                form: {
                    activity_id: '',
                    name: '',
                    goods_id: '',
                    batch_num: '',
                    start_time: '',
                    end_time: '',
                    status: 1,
                },
                loading: false,
                /*验证规则*/
                rules: {
                    activity_id: [{required: true, message: '活动id不能为空', trigger: 'blur'},],
                    name: [{required: true, message: '批次名称不能为空', trigger: 'blur'},],
                    goods_id: [{required: true, message: '商品id不能为空', trigger: 'blur'},],
                    batch_num: [{required: true, message: '总数量不能为空', trigger: 'blur'},],
                    start_time: [{required: true, message: '开始时间不能为空', trigger: 'blur'},],
                    end_time: [{required: true, message: '截止时间不能为空', trigger: 'blur'},],
                },

                dateArr:[]
            };
        },
        created() {
            this.form.activity_id = this.$route.query.activity_id;
            this.form.goods_id = this.$route.query.goods_id;
        },
        methods: {

            // 观察时间选择
            datePickerChange(e,type) {
                let start_date = e?e[0]:'';
                let end_date = e ? e[1] : '';
                this.form[type + 'start_time'] = start_date;
                this.form[type + 'end_time'] = end_date;
            },

            /*添加*/
            onSubmit() {
                let self = this;
                let form = self.form;
                self.$refs.form.validate((valid) => {
                    if (valid) {
                        self.loading = true;
                        PlatformActivityApi.batch.add(form, true)
                            .then((data) => {
                                self.loading = false;
                                self.$message({
                                    message: data.msg,
                                    type: "success"
                                });

                                //返回上一页
                                self.$router.back()
                            })
                            .catch((error) => {
                                self.loading = false;
                            });
                    }
                });
            },

            /*取消添加，返回列表*/
            cancelFunc() {
                this.$router.back();
            }
        }
    };
</script>

<style>
    .edit_container {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .ql-editor {
        height: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/views/platformactivity/batch/add.vue